<script setup lang="ts">
import Tooltip from '@/shared/ui/tooltip';

const msg = 'Ограничения обработки видео';
const tooltipMsg = 'По техническим причинам загрузка и обработка видео временно недоступна.';
</script>

<template>
  <tooltip :content="tooltipMsg">
    <div class="attention-chips">
      <img
        src="/icons/attention.svg"
        class="icon"
        area-hidden="true"
      />

      <span class="msg">{{ msg }}</span>
    </div>
  </tooltip>
</template>

<style scoped lang="postcss">
.attention-chips {
  --spacing: var(--space-s-var_01);
  --color-attention: 239 102 25;

  display: flex;
  align-items: center;
  font-size: 0;

  border-radius: var(--border-radius-rounded);
  max-width: 42px;
  overflow: hidden;
  padding: var(--spacing);

  border: 1px solid var(--color-white-12);
  background:
    radial-gradient(
      50% 50% at 50% 50%,
      rgb(var(--color-attention) / 40%) 0,
      rgb(var(--color-attention) / 0%) 100%
    ),
    rgb(var(--color-attention) / 4%);

  transition: max-width 0.3s ease-in-out;
  cursor: pointer;

  .msg {
    font-size: var(--font_size-base-s);
    white-space: nowrap;
    opacity: 0;
    transition: opacity 300ms ease-in-out;
    padding-left: var(--spacing);
  }

  &:hover {
    max-width: 260px;

    & .msg {
      opacity: 1;
    }
  }
}
</style>
